import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import {request} from '../../containers/actions';
import {setMaterials, addMaterial, removeMaterial, toggleMaterial} from './actions';
import {setSubjects, addSubject, removeSubject,
    toggleSubject, toggleSubjectSelection} from './actions';
import mainReducer from './reducer';

function isChild(item, parent, field, subjects) {
    if (item[field] === parent.id)
        return true;
    while (item.parent) {
        item = subjects[item.parent];
        if (item[field] === parent.id)
            return true;
    }
    return false;
}

class DummyTag extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    render() {
        let parentField;
        switch (this.props.parent.type) {
        case 'material':
            parentField = 'material';
            break;

        case 'subject':
            parentField = 'parent';
            break;
        }
        const {colorCode} = this.props;
        const items = _.filter(
            _.values(this.props.subjects),
            subject => subject[parentField] === this.props.parent.id,
        );
        const childrenCount = _.countBy(
            _.values(this.props.subjects),
            subject => subject[parentField] === this.props.parent.id,
        )['true'];
        const selectedCount = _.countBy(
            _.values(this.props.subjects),
            subject => (
                isChild(subject, this.props.parent, parentField, this.props.subjects) &&
                this.props.selectedSubjects[subject.id]
            ),
        )['true'];
        const isOpen = this.props.parent.type === 'material'
            ? this.props.openedMaterials[this.props.parent.id]
            : this.props.openedSubjects[this.props.parent.id];
        return <span>
            <div
                style={(this.props.parent.type === 'material'
                    ? this.props.selectedMaterials[this.props.parent.id]
                    : this.props.selectedSubjects[this.props.parent.id])
                    ? styles.selectedItem
                    : {
                        ...styles.item,
                        backgroundColor: styles.item.backgroundColor[colorCode],
                    }
                }
                onClick={event => {
                    if (this.props.parent.type === 'material')
                        return;
                    event.stopPropagation();
                    this.context.store.dispatch(toggleSubjectSelection(
                        this.props.parent,
                        this.props.elementId,
                    ));
                }}
                >
                {this.props.parent.title.persian()}
                {selectedCount ? ` (${selectedCount.persian()})` : null}
                {childrenCount
                        ? <span
                            style={{cursor: 'pointer'}}
                            onClick={event => {
                                event.stopPropagation();
                                if (this.props.parent.type === 'material') {
                                    this.context.store.dispatch(toggleMaterial(
                                        this.props.parent,
                                        this.props.elementId,
                                    ));
                                }
                                else {
                                    this.context.store.dispatch(toggleSubject(
                                        this.props.parent,
                                        this.props.elementId,
                                    ));
                                }
                            }}
                            >
                            {isOpen ? '▼' : '◀'}
                        </span>
                        : null
                }
                {this.props.readonly
                        ? null
                        : <span>
                            <div
                                key='remove'
                                style={styles.leftAction}
                                onClick={event => {
                                    event.stopPropagation();
                                    if (this.props.parent.type === 'material')
                                        this.props.removeMaterial(this.props.parent);
                                    else
                                        this.props.removeSubject(this.props.parent);
                                }}>
                                <i className='fa-trash-o'></i>
                            </div>
                            <div
                                key='add'
                                style={styles.rightAction}
                                onClick={event => {
                                    event.stopPropagation();
                                    this.props.addSubject(this.props.parent, this.props.parent.type === 'material');
                                }}>
                                <i className='fa-plus'></i>
                            </div>
                        </span>
                }
            </div>
            {isOpen
                ? <ul style={styles.ul}>
                    {_.map(
                        items,
                        item => <li
                            key={item.id}
                            style={styles.li}
                            >
                            <DummyTag
                                {...this.props}
                                parent={{type: 'subject', ...item}}
                                colorCode={1 - colorCode}
                            />
                        </li>,
                    )}
                </ul>
                : null
            }
        </span>;
    }
}

export default class ScienceTree extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        pending: PropTypes.number,
    }

    static defaultProps = {
        readonly: false,
        header: true,
    }

    constructor(props) {
        super(props);
        this.addSubject = this.addSubject.bind(this);
        this.removeSubject = this.removeSubject.bind(this);
        this.removeMaterial = this.removeMaterial.bind(this);
    }

    componentDidMount() {
        if (!this.props.materials) {
            this.fetch.bind(this)();
        }
    }

    async fetch() {
        let materials = [];
        let subjects = [];
        this.context.store.dispatch([
            setMaterials([], this.props.elementId),
            setSubjects([], this.props.elementId),
        ]);
        try {
            [materials, subjects] = _.map(await Promise.all([
                this.context.store.dispatch(
                    request('/material/?limit=100000'),
                ),
                this.context.store.dispatch(
                    request('/subject/?limit=100000&fields=!parent_subjects,parent_material'),
                ),
            ]), response => response.results);
        }
        catch (exception) {
            console.error(exception);
        }
        this.context.store.dispatch([
            setMaterials(materials, this.props.elementId),
            setSubjects(subjects, this.props.elementId),
        ]);
    }

    async addMaterial() {
        const title = prompt(window.gettext('Enter a title:'));
        if (!title) {
            return;
        }
        const material = await this.context.store.dispatch(request({
            path: '/material/',
            body: {title},
            method: 'POST',
        }));
        this.context.store.dispatch(addMaterial(
            material,
            this.props.elementId,
        ));
    }

    async removeMaterial(material) {
        const confirmed = window.confirm(window.gettext(
            'Are you sure you want to delete this material?',
        ));
        if (!confirmed)
            return;
        await this.context.store.dispatch(request({
            path: `/material/${material.id}/`,
            method: 'DELETE',
        }));
        this.context.store.dispatch(removeMaterial(
            material,
            this.props.elementId,
        ));
    }

    async addSubject(parent, toMaterial = false) {
        const title = prompt(window.gettext('Enter a title:'));
        if (!title) {
            return;
        }
        const subject = await this.context.store.dispatch(request({
            path: '/subject/',
            body: {
                title,
                [toMaterial ? 'material' : 'parent']: parent.id,
            },
            method: 'POST',
        }));
        this.context.store.dispatch(addSubject(
            subject,
            this.props.elementId,
        ));
    }

    async removeSubject(subject) {
        const confirmed = window.confirm(window.gettext(
            'Are you sure you want to delete this subject?',
        ));
        if (!confirmed)
            return;
        await this.context.store.dispatch(request({
            path: `/subject/${subject.id}/`,
            method: 'DELETE',
        }));
        this.context.store.dispatch(removeSubject(
            subject,
            this.props.elementId,
        ));
    }

    render() {
        window.counter = window.counter || 0;
        window.counter++;
        console.log(window.counter);
        if (!this.props.materials || !this.props.subjects)
            return <div>{window.gettext('Loading')}...</div>;
        return <div>
            {this.props.header
                ? <div style={{
                    ...styles.item,
                    backgroundColor: styles.item.backgroundColor[0],
                    height: 'unset',
                }}>
                    {window.gettext('Science Tree')}
                    {
                        _.countBy(
                            _.values(this.props.subjects),
                            label => this.props.selectedSubjects[label.id],
                        )['true'] > 0
                            ? ': '
                            : null
                    }
                    {this.props.readonly
                        ? null
                        : <span>
                            {/* <div */}
                            {/*     key={'delete' + key} */}
                            {/*     style={styles.leftAction} */}
                            {/*     onClick={event => { */}
                            {/*         event.stopPropagation(); */}
                            {/*         this.removeMaterial.bind(this)(item); */}
                            {/*     }}> */}
                            {/*     <i className='fa-trash-o'></i> */}
                            {/* </div> */}
                            <div
                                key='add'
                                style={styles.rightAction}
                                onClick={event => {
                                    event.stopPropagation();
                                    this.addMaterial.bind(this)();
                                }}>
                                <i className='fa-plus'></i>
                            </div>
                        </span>
                    }
                    <div style={{overflow: 'hidden'}}>
                        {_.map(
                            this.props.selectedSubjects,
                            (value, key) => <div
                                key={key}
                                style={{
                                    marginRight: '.5rem',
                                    float: 'right',
                                    width: 'calc(100% - .5rem)',
                                }}>
                                {(value || '').persian()}
                            </div>,
                        )}
                    </div>
                </div>
                : null
            }
            <ul
                style={{
                    ...styles.ul,
                    paddingRight: this.props.header ? undefined : 'unset',
                }}>
                {_.map(
                    this.props.materials,
                    item => <li
                        key={item.id}
                        style={styles.li}>
                        <DummyTag
                            {...this.props}
                            parent={{type: 'material', ...item}}
                            addSubject={this.addSubject}
                            removeMaterial={this.removeMaterial}
                            removeSubject={this.removeSubject}
                            colorCode={1}
                            items={this.items}
                            elementId={this.props.elementId}
                            selectedMaterials={this.props.selectedMaterials}
                            selectedSubjects={this.props.selectedSubjects}
                            openedMaterials={this.props.openedMaterials}
                            openedSubjects={this.props.openedSubjects}
                            readonly={this.props.readonly}
                        />
                    </li>,
                )}
            </ul>
        </div>;
    }
}

const styles = {};
styles.ul = {
    paddingRight: '2.5em',
};
styles.li = {
    display: 'block',
    listStyleType: 'none',
};
styles.item = {
    width: '100%',
    backgroundColor: ['bcbcbc', 'e6e6e6'],
    padding: '.25em',
    marginBottom: '.25em',
    boxSizing: 'border-box',
    height: '2.25em',
};
styles.selectedItem = {
    ...styles.item,
    backgroundColor: '79c8ae',
};
styles.itemAction = {
    display: 'flex',
    cursor: 'pointer',
    fontSize: '1.2em',
    color: '8a8a8a',
    height: '100%',
    alignItems: 'center',
    marginLeft: '.25em',
    marginRight: '.25em',
    height: '1.75em',
};
styles.leftAction = {
    ...styles.itemAction,
    float: 'left',
};
styles.rightAction = {
    ...styles.itemAction,
    float: 'right',
};

export const initialState = {
    tree: {elementId: 'scienceTree'},
};

export const reducer = mainReducer;

export const component = ScienceTree;
